/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';
import { SPACING_L, SPACING_S } from '@veeam/components';

export const CellStylesReset = styled.div`
    margin: -${SPACING_S} -${SPACING_L} -${SPACING_S} -${SPACING_S};
`;
